import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import breadcrumbImage from "../../assets/images/course/cousre.jpg";
import swal from "sweetalert";
import {
  Container,
  Form,
  Row,
  Col,
  Alert,
  Card,
  CardBody,
} from "react-bootstrap";

function Scholarship() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    dateOfBirth: "",
    gender: "",
    school_name: "",
    pas_year: "test",
    aadhar_number: "",
    percentage: "",
    description: "test",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
   const [bgImage, setBgImage] = useState("");
  const [apiError, setApiError] = useState("");
  const [files, setFiles] = useState({
    exammarksheet: null,
    upload_aadhar_front: null,
    upload_aadhar_back: null,
  });
  useEffect(() => {
   
      bannerimg()
  }, []);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleFileChange = (e) => {
    setFiles({
      ...files,
      [e.target.name]: e.target.files[0],
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.dateOfBirth)
      newErrors.dateOfBirth = "Date of birth is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.school_name)
      newErrors.school_name = "School name is required";
    // if (!formData.pas_year) newErrors.pas_year = "Passing year is required";
    if (!formData.aadhar_number)
      newErrors.aadhar_number = "Aadhar number is required";
    if (!formData.percentage) newErrors.percentage = "Percentage is required";
    if (!formData.description)
      newErrors.description = "Description is required";

    if (!files.exammarksheet)
      newErrors.exammarksheet = "Marksheet file is required";
    if (!files.upload_aadhar_front)
      newErrors.upload_aadhar_front = "Aadhar front image is required";
    if (!files.upload_aadhar_back)
      newErrors.upload_aadhar_back = "Aadhar back image is required";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // setErrors({});
    const formPayload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formPayload.append(key, value);
    });

    formPayload.append("exammarksheet", files.exammarksheet);
    formPayload.append("upload_aadhar_front", files.upload_aadhar_front);
    formPayload.append("upload_aadhar_back", files.upload_aadhar_back);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/create-scholarship`,
        formPayload
      );

      if (res.data.success === "1") {
        swal("Success", res.data.message, "success");
        setTimeout(() => {
          navigate("/");
        }, 2000);
        setSubmitted(true);
        setTimeout(() => setSubmitted(false), 5000);
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          dateOfBirth: "",
          gender: "",
          school_name: "",
          pas_year: "",
          aadhar_number: "",
          percentage: "",
          description: "",
        });
        setFiles({
          exammarksheet: null,
          upload_aadhar_front: null,
          upload_aadhar_back: null,
        });
      } else {
        swal("Error", "Failed to submit. Please try again.", "error");
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Something went wrong! Please try again.", "error");
    }
  };


   const bannerimg = async () => {
                  try {
                    const res = await axios.get(
                      `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
                    );
              
                    const baseUrl = res.data.imagePath;
                    const courseImage = res.data.home_setting[0]?.course_image;
              
                    // Full image URL
                    const fullUrl = baseUrl + courseImage;
              
                    setBgImage(fullUrl);
                  } catch (error) {
                    console.error("Error fetching banner:", error);
                  }
                };

  return (
    <section className="Scholarship course">
      <div className="page_header"></div>
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Scholarship</h1>
        </div>
      </div>
      <Container className="my-5">
        {submitted && (
          <Alert variant="success">Your application has been submitted!</Alert>
        )}
        {apiError && <Alert variant="danger">{apiError}</Alert>}
        <Card className="shadow_light">
          <CardBody>
            <h2 className="mb-5 text-center fs-1 scholar_header">
              Scholarship Application Form
            </h2>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="fullName">
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your full name"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      isInvalid={!!errors.fullName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fullName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="phone">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Enter your phone number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      isInvalid={!!errors.phone}
                      maxLength={10}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3" controlId="dateOfBirth">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      max={new Date().toISOString().split("T")[0]}
                      isInvalid={!!errors.dateOfBirth}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.dateOfBirth}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="gender">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      isInvalid={!!errors.gender}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.gender}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3" controlId="school_name">
                    <Form.Label>School Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="school_name"
                      value={formData.school_name}
                      onChange={handleChange}
                      isInvalid={!!errors.school_name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.school_name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                {/* <Col md={6}>
                  <Form.Group className="mb-3" controlId="pas_year">
                    <Form.Label>Passing Year</Form.Label>
                    <Form.Control
                      type="number"
                      name="pas_year"
                      value={formData.pas_year}
                      onChange={handleChange}
                      isInvalid={!!errors.pas_year}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.pas_year}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col> */}

                <Col md={6}>
                  <Form.Group className="mb-3" controlId="aadhar_number">
                    <Form.Label>Aadhar Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="aadhar_number"
                      value={formData.aadhar_number}
                      onChange={handleChange}
                      isInvalid={!!errors.aadhar_number}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                      }}
                      maxLength={12}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.aadhar_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="address">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={1}
                      placeholder="Enter your address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="percentage">
                    <Form.Label>Percentage (10th/12th)</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter your percentage"
                      name="percentage"
                      value={formData.percentage}
                      onChange={handleChange}
                      isInvalid={!!errors.percentage}
                      onKeyPress={(e) => {
                        const char = String.fromCharCode(e.which);
                        if (!/[0-9.]*/.test(char)) e.preventDefault();
                      }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.percentage}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Exam Marksheet (10th/12th)</Form.Label>
                    <Form.Control
                      type="file"
                      name="exammarksheet"
                      onChange={handleFileChange}
                      accept=".pdf,.jpg,.jpeg,.png"
                      isInvalid={!!errors.exammarksheet}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.exammarksheet}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              {/* <Form.Group className="mb-3" controlId="description">
                <Form.Label>Why do you deserve this scholarship?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Write your description..."
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  isInvalid={!!errors.description}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.description}
                </Form.Control.Feedback>
              </Form.Group> */}
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Aadhar Front</Form.Label>
                    <Form.Control
                      type="file"
                      name="upload_aadhar_front"
                      onChange={handleFileChange}
                      isInvalid={!!errors.upload_aadhar_front}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.upload_aadhar_front}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Aadhar Back</Form.Label>
                    <Form.Control
                      type="file"
                      name="upload_aadhar_back"
                      onChange={handleFileChange}
                      isInvalid={!!errors.upload_aadhar_back}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.upload_aadhar_back}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <button type="submit" className="educate-btn">
                <span className="educate-btn__curve" />
                Submit Application
              </button>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </section>
  );
}

export default Scholarship;
